export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/applause-icon.png?f4925efc152c51192b1a2cc8f7b8b803";